<template>
  <v-dialog v-model="dialog" persistent max-width="350">
    <template v-slot:activator="{ on }">
      <v-btn block :loading="dialog" :color="btnColor" v-on="on"
        >Exchange</v-btn
      >
    </template>
    <v-card>
      <v-toolbar flat color="lime">
        <v-toolbar-title
          >Account {{ AccountNumber.toLocaleString() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon :loading="Loading" @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <Exchange
        :showBalance="showBalance"
        :AccountNumber="AccountNumber"
        :closed="dialog"
        :isLoading="isLoading"
      ></Exchange>
    </v-card>
  </v-dialog>
</template>
<script>
import ExchangeBank from "./ExchangeBank";
export default {
  props: {
    AccountNumber: [String],
    Finished: [Function],
    btnColor: { type: String, default: "success" },
  },
  components: { Exchange: ExchangeBank },
  data() {
    return {
      Loading: false,
      dialog: false,
    };
  },
  methods: {
    showBalance(data) {
      this.Finished(data);
    },
    isLoading(val = false, isFinish = "No") {
      this.Loading = val;
      if (isFinish == "Finished") this.dialog = false;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
